<template>
  <!-- <progressBar :percentage="userData.progress" /> -->
  <extend
    v-if="openExtend"
    @closeModal="openExtend = false"
    :props-item="'gala'"
  />
  <ReviewModal
    v-if="openReview"
    @closeModal="openReview = false"
    :document_id="selectedDocumentId"
    :document_name="selectedDocumentName"
    @getNewData="getUser()"
  />
  <PlatformLayout layout-class="home" title="Личный кабинет">
      <nav class="home-tabs" aria-label="Разделы личного кабинета">
        <swiper
          class="home-tabs__swiper"
          @swiper="getSwiperCategory"
          :breakpoints="{ 0: { slidesPerView: 'auto' } }"
          :space-between="8"
          :speed="400"
        >
          <swiper-slide
            v-for="(tab, index) in tabs"
            :key="tab.name"
            class="home-tabs__slide"
            :class="{ 'home-tabs__slide--active': selectedTab === index }"
            @click="selectTab(index)"
          >
            {{ tab.name }}
          </swiper-slide>
        </swiper>
      </nav>
      <div class="main" v-if="selectedTab == 0">
        <div v-if="mainTabLoading" class="home-page-sk" aria-busy="true" aria-label="Загрузка данных">
          <div v-if="$store.state.role !== 'guest'" class="sk sk--focus" />
          <div class="home-sk-grid">
            <div class="sk sk--panel" />
            <div class="sk sk--panel" />
            <div class="sk sk--panel" />
          </div>
          <div class="home-sk-mobile">
            <div class="sk sk--block" />
            <div class="sk sk--block" />
            <div class="sk sk--block" />
          </div>
        </div>
        <template v-else>

        <!-- Focus card — not for guests, they have GuestBanner -->
        <div class="focus-card" :class="focusCard.theme" v-if="agree && $store.state.role !== 'guest'">
          <div class="focus-card__accent"></div>
          <div class="focus-card__body">
            <div class="focus-card__stat" v-for="stat in focusCard.stats" :key="stat.label">
              <span class="focus-card__stat__value" :class="stat.valueClass">{{ stat.value }}</span>
              <span class="focus-card__stat__label">{{ stat.label }}</span>
            </div>
          </div>
          <button v-if="focusCard.cta" class="focus-card__cta" @click="openExtendEvent">
            {{ focusCard.cta }}
          </button>
        </div>

        <div class="main__top">
          <div class="main__top__left">
            <div class="guest-value-card" v-if="$store.state.role === 'guest'">
              <div class="guest-value-card__header">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#11415D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
                <p>Что вы получите</p>
              </div>
              <ul class="guest-value-card__list">
                <li>Персональный план поступления</li>
                <li>Куратор на весь период обучения</li>
                <li>3 540+ программ без ограничений</li>
                <li>Отслеживание ключевых сроков</li>
                <li>Проверка документов и эссе</li>
              </ul>
              <button class="guest-value-card__btn" @click="navigateToPay()">Получить доступ →</button>
            </div>
            <div class="status" v-if="$store.state.role !== 'guest'">
              <div class="customTitle">
                <p>Статус договора</p>
                <div class="line"></div>
              </div>
              <div class="status__block">
                <div class="status__block__left">
                  <CanvasJSChart
                    :options="chartOptions"
                    style="background-color: inherit"
                  />
                  <p v-if="agree.status == 1">{{ agree.left_days }} дней</p>
                  <p v-if="agree.status == 2">0 дней</p>
                </div>
                <div class="status__block__right">
                  <p
                    class="status__block__right__title"
                    :class="{ customGreen: agree.status == 1 }"
                    v-if="agree.status == 1 && agree.left_days > 0"
                  >
                    Действует
                  </p>
                  <p
                    class="status__block__right__title"
                    v-if="agree.status == 2 || agree.left_days == 0"
                  >
                    Истек
                  </p>
                  <p style="color: rgba(0, 0, 0, 0.5411764706)">
                    № {{ agree.contract_number }} от {{ agree.send_date }}
                  </p>
                  <button
                    @click="openExtendEvent"
                    :class="{
                      customGreenBack: agree.status == 1 && agree.left_days > 0,
                    }"
                  >
                    Продлить
                  </button>
                </div>
              </div>
            </div>
            <div class="deadlines">
              <div class="customTitle">
                <p>Ключевые сроки</p>
                <div class="line"></div>
              </div>
              <div class="deadlines__block">
                <div v-if="$store.state.role !== 'guest' && !deadlines?.generalEnglishes?.length && !deadlines?.tests?.length" class="empty-state empty-state--small">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#C4C9D4" stroke-width="1.5" stroke-linecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  <p class="empty-state__text">Ключевые сроки ещё не назначены</p>
                </div>
                <div v-else-if="$store.state.role === 'guest' && !deadlines?.generalEnglishes?.length && !deadlines?.tests?.length" class="guest-locked-preview">
                  <div class="guest-locked-preview__item" v-for="d in guestDeadlinesPreview" :key="d.title">
                    <div class="guest-locked-preview__dot"></div>
                    <p class="guest-locked-preview__title">{{ d.title }}</p>
                    <p class="guest-locked-preview__meta">{{ d.date }}</p>
                  </div>
                  <p class="guest-locked-preview__hint">
                    <svg width="12" height="12" viewBox="0 -960 960 960" fill="currentColor"><path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-200q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z"/></svg>
                    Ваши дедлайны появятся после получения доступа
                  </p>
                </div>
                <div class="deadlines__block__in" v-if="deadlines?.generalEnglishes?.length">
                  <p class="deadlines__block__in__title">General English</p>
                  <div class="deadlines__block__in__new">
                    <div
                      class="deadlines__block__in__new__in"
                      v-for="(newItem, newIndex) in deadlines.generalEnglishes"
                      :key="newIndex"
                    >
                      <div class="deadlines__block__in__new__in__left">
                        <div class="deadlines__block__in__new__in__left__mini">
                          <div
                            class="deadlines__block__in__new__in__left__mini__in"
                            :class="{
                              backGreen: newItem.status == 0,
                              backRed: newItem.status == 1,
                              customRedBack:
                                newItem.is_coming && newItem.status != 0,
                              backWhite:
                                newItem.status !== 1 && newItem.status !== 0,
                            }"
                          ></div>
                        </div>
                        <p
                          :class="{
                            textGreen: newItem.status == 0,
                            textRed: newItem.status == 1,
                            customRed1:
                              newItem.is_coming && newItem.status != 0,
                          }"
                        >
                          {{ newItem.title }}
                        </p>
                      </div>
                      <div class="deadlines__block__in__new__in__right">
                        <p
                          :class="{
                            textRed: newItem.status == 1,
                            textGreen: newItem.status == 0,
                            customRed1:
                              newItem.is_coming && newItem.status != 0,
                          }"
                        >
                          {{ newItem.deadline }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="deadlines__block__in" v-if="deadlines?.tests?.length">
                  <p class="deadlines__block__in__title">Тесты</p>
                  <div class="deadlines__block__in__new">
                    <div
                      class="deadlines__block__in__new__in"
                      v-for="(newItem, newIndex) in deadlines.tests"
                      :key="newIndex"
                    >
                      <div class="deadlines__block__in__new__in__left">
                        <div class="deadlines__block__in__new__in__left__mini">
                          <div
                            class="deadlines__block__in__new__in__left__mini__in"
                            :class="{
                              backGreen: newItem.status == 0,
                              backRed: newItem.status == 1,
                              backWhite:
                                newItem.status !== 1 && newItem.status !== 0,
                            }"
                          ></div>
                        </div>
                        <p
                          :class="{
                            textGreen: newItem.status == 0,
                            textRed: newItem.status == 1,
                          }"
                        >
                          {{ newItem.title }}
                        </p>
                      </div>
                      <div class="deadlines__block__in__new__in__right">
                        <p
                          :class="{
                            textRed: newItem.status == 1,
                            textGreen: newItem.status == 0,
                          }"
                        >
                          {{ newItem.deadline }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main__top__center">
            <div class="customTitle">
              <p>Утвержденные программы</p>
              <div class="line"></div>
            </div>
            <div class="main__top__center__block">
              <div v-if="$store.state.role !== 'guest' && (!admissions || admissions.length === 0)" class="empty-state">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#C4C9D4" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M3 9h18M9 21V9"/></svg>
                <p class="empty-state__text">Программы ещё не выбраны</p>
                <button class="empty-state__btn" @click="$router.push('/programs')">Найти программу →</button>
              </div>
              <template v-else-if="$store.state.role === 'guest' && (!admissions || !admissions.length)">
                <div class="guest-prog-card" v-for="prog in guestPreviewPrograms" :key="prog.university">
                  <div class="guest-prog-card__thumb" :style="{ background: prog.gradient }">
                    <span class="guest-prog-card__initial">{{ prog.initial }}</span>
                    <span class="guest-prog-card__flag">{{ prog.flag }}</span>
                  </div>
                  <div class="guest-prog-card__info">
                    <p class="guest-prog-card__program">{{ prog.program }}</p>
                    <p class="guest-prog-card__uni">{{ prog.university }}</p>
                    <div class="guest-prog-card__tags">
                      <span class="guest-prog-card__tag guest-prog-card__tag--elite">Elite</span>
                      <span class="guest-prog-card__tag">{{ prog.category }}</span>
                    </div>
                  </div>
                  <div class="guest-prog-card__lock">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 -960 960 960" fill="currentColor"><path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-200q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z"/></svg>
                  </div>
                </div>
                <button class="guest-prog-unlock" @click="$router.push('/programs')">Открыть все программы →</button>
              </template>
              <div
                v-else
                class="main__top__center__block__in"
                v-for="item in admissions"
                :key="item"
                @click="this.$router.push({ name: 'program', params: { id: item?.program?.id } });"
              >
                <div
                  class="main__top__center__block__in__left"
                  :style="{
                    backgroundImage: `url('${item?.program?.images[0]?.image}')`,
                  }"
                >
                  <img
                    src="@/assets/icons/crown.svg"
                    v-if="
                      item?.admission_status?.package &&
                      item?.admission_status?.package?.id != 6
                    "
                  />
                </div>
                <div class="main__top__center__block__in__right">
                  <p class="main__top__center__block__in__right__title">
                    <span v-if="item?.admission_status?.priority">{{
                      item?.admission_status?.priority
                    }}</span>
                  {{ item?.program?.university?.title }}
                  </p>
                  <p class="main__top__center__block__in__right__sub">
                    {{ item?.program?.programName }}
                  </p>
                  <p class="main__top__center__block__in__right__deadline">
                    Срок подачи: {{ item?.program?.autumn_admission_end_date }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="main__top__right">
            <div class="grant">
              <div class="customTitle">
                <p>Международная стипендия</p>
                <div class="line"></div>
              </div>
              <div class="grant__block">
                <div v-if="$store.state.role !== 'guest' && (!intSch || intSch.length === 0)" class="empty-state empty-state--small">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#C4C9D4" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>
                  <p class="empty-state__text">Информация о стипендии пока недоступна</p>
                </div>
                <template v-else-if="$store.state.role === 'guest' && (!intSch || intSch.length === 0)">
                  <div class="guest-locked-preview guest-locked-preview--compact">
                    <div class="guest-locked-preview__item" v-for="s in guestScholarshipPreview" :key="s.title">
                      <div class="guest-locked-preview__dot guest-locked-preview__dot--blue"></div>
                      <p class="guest-locked-preview__title">{{ s.title }}</p>
                      <p class="guest-locked-preview__meta">{{ s.status }}</p>
                    </div>
                    <p class="guest-locked-preview__hint">
                      <svg width="12" height="12" viewBox="0 -960 960 960" fill="currentColor"><path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-200q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z"/></svg>
                      Доступно после получения доступа
                    </p>
                  </div>
                </template>
                <div
                  v-else
                  class="grant__block__in"
                  v-for="i in intSch.slice(0, 2)"
                  :key="i.id"
                >
                  <p class="grant__block__in__name">{{ i.title }}</p>
                  <p class="grant__block__in__date">{{ i.date }}</p>
                </div>
                <!-- <div class="grant__block__in">
                                    <p class="grant__block__in__name">Конкурсный<br /> отбор</p>
                                    <p class="grant__block__in__date">{{ intSch[1]?.date }}</p>
                                </div> -->
              </div>
            </div>
            <div class="risk">
              <div class="customTitle">
                <p>Возможные риски</p>
                <div class="line"></div>
              </div>
              <div class="risk__block">
                <template v-if="$store.state.role === 'guest'">
                  <ul class="risk__block__in" v-for="item in guestRisks" :key="item">
                    <li>{{ item }}</li>
                  </ul>
                </template>
                <template v-else>
                  <ul class="risk__block__in" v-for="item in risks" :key="item">
                    <li>{{ item.title }}</li>
                  </ul>
                </template>
              </div>
            </div>
            <div class="contact">
              <div class="customTitle">
                <p>КОНТАКТЫ И ПОМОЩЬ</p>
                <div class="line"></div>
              </div>
              <div class="contact__block">
                <swiper
                  :slidesPerView="4"
                  :spaceBetween="20"
                  :navigation="{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  }"
                  :autoplay="{
                    delay: 3000,
                  }"
                  :speed="1000"
                  :lazy="true"
                >
                  <swiper-slide v-for="item in contacts" :key="item">
                    <a :href="item.link"><img :src="item.icon" /></a>
                    <a
                      :href="item.link"
                      v-html="item.title"
                      style="text-align: center; color: black"
                    ></a>
                  </swiper-slide>
                  <swiper-slide>
                    <a :href="drive_link"
                      ><img src="@/assets/icons/drive.svg"
                    /></a>
                    <a
                      :href="drive_link"
                      style="text-align: center; color: black"
                      >Google Drive</a
                    >
                  </swiper-slide>
                </swiper>
              </div>
              <div
                class="contact__in__backdrop"
                v-if="$store.state.role == 'guest'"
                @click="toggleBlock(true)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="48px"
                  viewBox="0 -960 960 960"
                  width="48px"
                  fill="#fff"
                >
                  <path
                    d="M753-249q27.92 0 47.46-19.56t19.54-47.5Q820-344 800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19.25 47.15T753-249Zm-.21 133Q786-116 815-131.5t47-42.5q-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5ZM350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM557-80H220q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v87q-13-3-27-4t-33-1v-82H220v434h301q7 17 15 30.5T557-80Zm196 34q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136T753-46ZM220-574v434-434Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-[10px] new">
          <section class="w-full grid grid-cols-2 gap-5">
            <article
              class="status border border-black/30 rounded-2xl p-3 flex flex-col gap-6"
            >
              <h2 class="flex items-center justify-center gap-2">
                <span class="text-[14px] text-black/50">Статус договора</span>
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.79175 12.0415H9.20842V7.7915H7.79175V12.0415ZM8.50008 6.37484C8.70078 6.37484 8.86912 6.30684 9.00512 6.17084C9.14112 6.03484 9.20889 5.86673 9.20842 5.6665C9.20794 5.46628 9.13994 5.29817 9.00442 5.16217C8.86889 5.02617 8.70078 4.95817 8.50008 4.95817C8.29939 4.95817 8.13128 5.02617 7.99575 5.16217C7.86022 5.29817 7.79222 5.46628 7.79175 5.6665C7.79128 5.86673 7.85928 6.03507 7.99575 6.17155C8.13222 6.30802 8.30033 6.37578 8.50008 6.37484ZM8.50008 15.5832C7.52022 15.5832 6.59939 15.3971 5.73758 15.025C4.87578 14.6529 4.12612 14.1483 3.48862 13.5113C2.85112 12.8743 2.34655 12.1246 1.97492 11.2623C1.60328 10.4001 1.41722 9.47923 1.41675 8.49984C1.41628 7.52045 1.60233 6.59962 1.97492 5.73734C2.3475 4.87506 2.85207 4.12541 3.48862 3.48838C4.12518 2.85135 4.87483 2.34678 5.73758 1.97467C6.60033 1.60256 7.52117 1.4165 8.50008 1.4165C9.479 1.4165 10.3998 1.60256 11.2626 1.97467C12.1253 2.34678 12.875 2.85135 13.5115 3.48838C14.1481 4.12541 14.6529 4.87506 15.026 5.73734C15.399 6.59962 15.5848 7.52045 15.5834 8.49984C15.582 9.47923 15.3959 10.4001 15.0253 11.2623C14.6546 12.1246 14.15 12.8743 13.5115 13.5113C12.8731 14.1483 12.1234 14.6531 11.2626 15.0257C10.4017 15.3983 9.48089 15.5841 8.50008 15.5832ZM8.50008 14.1665C10.082 14.1665 11.422 13.6175 12.5199 12.5196C13.6178 11.4217 14.1667 10.0818 14.1667 8.49984C14.1667 6.91789 13.6178 5.57796 12.5199 4.48005C11.422 3.38213 10.082 2.83317 8.50008 2.83317C6.91814 2.83317 5.57821 3.38213 4.48029 4.48005C3.38237 5.57796 2.83342 6.91789 2.83342 8.49984C2.83342 10.0818 3.38237 11.4217 4.48029 12.5196C5.57821 13.6175 6.91814 14.1665 8.50008 14.1665Z"
                    fill="black"
                    fill-opacity="0.3"
                  />
                </svg>
              </h2>
              <div class="flex flex-col">
                <span
                  class="text-2xl font-bold text-center"
                  :class="{ 'text-c-green': agree.status == 1 }"
                  v-if="agree.status == 1 && agree.left_days > 0"
                  >Действует</span
                >
                <span
                  class="text-[24px] font-bold text-c-red text-center"
                  v-if="agree.status == 2 || agree.left_days == 0"
                  >Истек</span
                >
                <span
                  class="text-[14px] text-black/30 text-center"
                  v-if="agree.status == 1"
                  >{{ agree.left_days }} дней</span
                >
                <span
                  class="text-[14px] text-black/30 text-center"
                  v-if="agree.status == 2"
                  >0 дней</span
                >
                <button
                  class="bg-c-red"
                  @click="openExtendEvent"
                  :class="{
                    customGreenBack: agree.status == 1 && agree.left_days > 0,
                  }"
                >
                  Продлить
                </button>
              </div>
            </article>
            <article
              class="grant border border-black/30 rounded-2xl p-3 flex flex-col gap-3"
            >
              <h2 class="text-[14px] text-black/50 text-center">
                Межд. стипендия
              </h2>
              <div class="relative border border-black/30 p-2 space-y-3 divide-y-2">
                <hgroup
                  class="flex flex-col items-center gap-1"
                  v-for="i in intSch.slice(0, 2)"
                >
                  <span class="text-black/50 text-[12px]">{{ i.title }}</span>
                  <span class="text-black text-[14px] font-bold">{{
                    i.date
                  }}</span>
                </hgroup>
              </div>
            </article>
          </section>
          <section
            class="w-full border border-black/30 rounded-xl p-3 flex flex-col gap-[14px]"
          >
            <h2 class="text-black/50 text-[14px] text-center">
              Ключевые сроки
            </h2>
            <ul class="flex flex-col gap-[14px] p-0">
              <span class="text-[14px] text-black font-bold"
                >General English</span
              >
              <li
                v-for="i in deadlines.generalEnglishes"
                class="flex items-center gap-3"
              >
                <span
                  :class="[
                    `text-[14px] font-bold`,
                    i.status == 0 ? 'text-c-green' : 'text-c-red',
                  ]"
                  >{{ i.title }}</span
                >
                <span class="border border-black/30 flex-1" />
                <span :class="[`text-[14px] font-medium text-black/50`]">{{
                  i.deadline
                }}</span>
              </li>
              <span class="text-[14px] text-black font-bold">Тесты</span>
              <li v-for="i in deadlines.tests" class="flex items-center gap-3">
                <span
                  :class="[
                    `text-[14px] font-bold`,
                    i.status == 0 ? 'text-c-green' : 'text-c-red',
                  ]"
                  >{{ i.title }}</span
                >
                <span class="border border-black/30 flex-1" />
                <span :class="[`text-[14px] font-medium text-black/50`]">{{
                  i.deadline
                }}</span>
              </li>
            </ul>
          </section>
          <section
            class="program border border-black/30 rounded-xl p-3 flex flex-col gap-6"
          >
            <span class="w-full text-center text-[14px] text-black/50"
              >Утвержденные программы</span
            >
            <ul class="flex flex-col gap-3">
              <li v-for="item in admissions" class="flex gap-4" @click="this.$router.push({ name: 'program', params: { id: item?.program?.id } });">
                <img
                  :src="item?.program?.images[0]?.image"
                  alt=""
                  class="size-[62px] rounded-xl"
                />
                <hgroup class="flex flex-col gap-1">
                  <span class="text-c-red text-[14px]">{{
                    item?.admission_status?.priority
                  }} {{ item?.program?.university?.title }}</span>
                  <span class="truncate text-black font-bold">{{
                    item?.program?.programName
                  }}</span>
                  <span class="text-black/50 text-[14px]">
                    {{ item?.program?.autumn_admission_end_date }}
                  </span>
                </hgroup>
              </li>
            </ul>
          </section>
          <section class="risk rounded-xl py-2 px-3">
            <div class="flex flex-col gap-6 relative z-10">
              <span class="w-full text-center text-[14px] text-[#F5F7FB]"
                >Риски</span
              >
              <ul class="p-0 space-y-1.5 list-disc mobRisk">
                <li
                  v-for="i in risks"
                  class="text-white text-[14px] font-bold ml-6"
                >
                  {{ i.title }}
                </li>
              </ul>
            </div>
          </section>
          <section
            class="border border-black/30 rounded-xl py-2 px-3 flex flex-col gap-6"
          >
            <span class="w-full text-center text-[14px] text-black/50"
              >Контакты и помощь</span
            >
            <ul class="flex flex-wrap justify-center gap-6 mobSocials">
              <li v-for="i in contacts">
                <a :href="i.link" class="flex flex-col items-center gap-3">
                  <img :src="i.icon" alt="" class="size-15" />
                  <span class="text-[14px] w-full text-center text-black/50">{{
                    i.title
                  }}</span>
                </a>
              </li>
              <li>
                <a :href="drive_link" class="flex flex-col items-center gap-3">
                  <img src="@/assets/icons/drive.svg" alt="" class="size-15" />
                  <span class="text-[14px] w-full text-center text-black/50"
                    >Google Drive</span
                  >
                </a>
              </li>
            </ul>
          </section>
        </div>
        </template>
      </div>
      <div class="general" v-if="selectedTab == 1">
        <div v-if="userTabLoading" class="home-sk-form" aria-busy="true" aria-label="Загрузка профиля">
          <div v-for="n in 10" :key="n" class="sk sk--input" />
        </div>
        <template v-else>
        <div class="general__bot">
          <p class="general__bot__title">Личная информация</p>
          <div class="general__bot__inputs">
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="surname">Фамилия</label>
                <input
                  type="text"
                  id="surname"
                  v-model="userData.surname"
                  @input="validateCyrillicSurname"
                  @change="mainIsChanged()"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="name">Имя</label>
                <input
                  type="text"
                  id="name"
                  v-model="userData.name"
                  @input="validateCyrillicName"
                  @change="mainIsChanged()"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="iin">ИИН</label>
                <input
                  type="text"
                  id="iin"
                  v-model="userData.iin"
                  :disabled="userData.iin_status == 1"
                  @change="mainIsChanged()"
                />
                <img
                  src="@/assets/icons/galochka.svg"
                  v-if="userData.iin_status == 1"
                  class="customInput__img"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="sex">Пол</label>
                <customSelect
                  :list="genders"
                  v-model="userData.gender"
                  @change="mainIsChanged()"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="date">Дата рождения</label>
                <input
                  type="date"
                  value=""
                  id="date"
                  v-model="userData.birthday"
                  @change="mainIsChanged()"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="country">Страна</label>
                <customSelect
                  :list="countries"
                  @change="cityList(), mainIsChanged()"
                  v-model="userData.country_id"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in" v-if="userData.country_id">
              <div class="customInput">
                <label for="city">Город</label>
                <customSelect
                  :list="cities"
                  v-model="userData.city_id"
                  @change="mainIsChanged()"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="address">Адрес</label>
                <input
                  type="text"
                  id="address"
                  v-model="userData.address"
                  @change="mainIsChanged()"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="phone">Телефон</label>
                <input
                  type="text"
                  id="phone"
                  v-model="userData.phone"
                  @change="mainIsChanged()"
                />
                <!-- :disabled="userData.phone_status == 1" так просили -->
                <img
                  src="@/assets/icons/galochka.svg"
                  class="customInput__img"
                  v-if="userData.phone_status == 1"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="mail">Почта</label>
                <input
                  type="text"
                  id="mail"
                  v-model="userData.email"
                  disabled
                  @change="mainIsChanged()"
                  style="color: #0000004a"
                />
                <!-- :disabled="userData.email_status == 1" так попросили-->
                <img
                  src="@/assets/icons/galochka.svg"
                  class="customInput__img"
                  v-if="userData.email_status == 1"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="tg">Telegram</label>
                <input
                  type="text"
                  id="tg"
                  v-model="userData.telegram"
                  :disabled="userData.telegram_status == 1"
                  @change="mainIsChanged()"
                />
                <img
                  src="@/assets/icons/galochka.svg"
                  class="customInput__img"
                  v-if="userData.telegram_status == 1"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in">
              <div class="customInput">
                <label for="iduser">ID пользователя</label>
                <input
                  type="text"
                  id="iduser"
                  v-model="userData.id"
                  disabled
                  style="color: #0000004a"
                  @change="mainIsChanged()"
                />
              </div>
            </div>
            <div class="general__bot__inputs__in" style="width: 100%">
              <div class="customInput">
                <label>Другое</label>
                <textarea
                  v-model="userData.other"
                  placeholder="Дополнительная информация"
                  @change="mainIsChanged()"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="general__bot__buttons">
            <button class="general__bot__buttons__save" @click="updateUser()">
              Применить
            </button>
            <button class="general__bot__buttons__delete" @click="reload()">
              Сбросить
            </button>
          </div>
        </div>
        <div class="general__top">
          <p class="general__top__title">Ваши покупки</p>
          <div class="general__top__block">
            <div
              class="general__top__block__in"
              v-for="item in myBuys"
              :key="item"
            >
              <div class="customTitle">
                <!-- <p v-if="item.type == 1">Курсы</p>
                                <p v-if="item.type == 2">Премиум опция</p>
                                <p v-if="item.type == 3">Наставничество</p> -->
                <p>{{ item.package.category.name }}</p>
                <div class="line"></div>
              </div>
              <img src="@/assets/icons/mentorMe.svg" />
              <p
                class="general__top__block__in__name"
                v-if="item?.course?.type_name && item.type == 1"
              >
                {{ item?.course?.type_name }}
              </p>
              <p
                class="general__top__block__in__name"
                v-if="item?.package?.title && item.type == 3"
              >
                {{ item?.package?.title }}
              </p>
              <p
                class="general__top__block__in__sub"
                v-if="item.comment && item.type == 3"
              >
                {{ item?.comment }}
              </p>
              <p
                class="general__top__block__in__sub"
                v-if="item?.course?.title && item.type == 1"
              >
                {{ item?.course?.title }}
              </p>
            </div>
              <div
                  class="general__top__block__inMobile"
                  v-for="item in myBuys"
                  :key="item"
              >
                  <img src="@/assets/icons/mentorMe.svg" />
                  <div class="general__top__block__inMobile__subBlock">
                      <p class="general__top__block__inMobile__subBlock__t0">{{ item.package.category.name }}</p>
                      <p
                          class="general__top__block__inMobile__subBlock__t1"
                          v-if="item?.course?.type_name && item.type == 1"
                      >
                          {{ item?.course?.type_name }}
                      </p>
                      <p
                          class="general__top__block__inMobile__subBlock__t1"
                          v-if="item?.package?.title && item.type == 3"
                      >
                          {{ item?.package?.title }}
                      </p>
                      <p
                          class="general__top__block__inMobile__subBlock__t2"
                          v-if="item.comment && item.type == 3"
                      >
                          {{ item?.comment }}
                      </p>
                      <p
                          class="general__top__block__inMobile__subBlock__t2"
                          v-if="item?.course?.title && item.type == 1"
                      >
                          {{ item?.course?.title }}
                      </p>
                  </div>
              </div>
          </div>
        </div>
        </template>
      </div>
      <div class="result" v-if="selectedTab == 2">
        <div v-if="userTabLoading" class="home-sk-form" aria-busy="true" aria-label="Загрузка академических данных">
          <div v-for="n in 8" :key="n" class="sk sk--input" />
        </div>
        <template v-else>
        <p class="result__title">Академические данные</p>
        <div class="result__inputs">
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="school">Школа</label>
              <input
                type="text"
                id="school"
                v-model="results.school"
                :disabled="results.status_school == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_school == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="studyField">Углубленное изучение</label>
              <customSelect
                v-model="results.depth_study"
                :list="depthStudy"
                :disabled="results.status_depth_study == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_depth_study == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="averageScore">Средний балл аттестата</label>
              <input
                type="text"
                id="averageScore"
                v-model="results.gpa_school"
                :disabled="results.status_gpa_school == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_gpa_school == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="bachelorGPA">GPA Бакалавриат</label>
              <input
                type="text"
                id="bachelorGPA"
                v-model="results.gpa_bachelor"
                :disabled="results.status_gpa_bachelor == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_gpa_bachelor == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="placementLevel">Placement Test Level</label>
              <input
                type="text"
                id="placementLevel"
                placeholder="Введите уровень теста"
                v-model="results.placement_test_level"
                :disabled="results.status_placement_test_level == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_placement_test_level == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="placementDate">Placement Test Date</label>
              <input
                type="date"
                value=""
                id="placementDate"
                v-model="results.placement_test_date"
                :disabled="results.status_placement_test_date == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_placement_test_date == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="ielts">IELTS/TOEFL</label>
              <input
                type="text"
                id="ielts"
                v-model="results.ielts"
                :disabled="results.status_ielts == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_ielts == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="ieltsDate">IELTS/TOEFL Date</label>
              <input
                type="date"
                value=""
                id="ieltsDate"
                v-model="results.ielts_date"
                :disabled="results.status_ielts_date == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_ielts_date == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="sat">SAT</label>
              <input
                type="text"
                id="sat"
                v-model="results.sat"
                :disabled="results.status_sat == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_sat == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="sat">SAT Date</label>
              <input
                type="date"
                value=""
                id="sat"
                v-model="results.sat_date"
                :disabled="results.status_sat_date == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_sat_date == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="kazTest">KazTest/Qazresmi</label>
              <input
                type="text"
                id="kazTest"
                v-model="results.kaz_test"
                :disabled="results.status_kaz_test == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_kaz_test == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="kazTestDate">KazTest/Qazresmi Date</label>
              <input
                type="date"
                value=""
                v-model="results.kaz_test_date"
                :disabled="results.status_kaz_test_date == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_kaz_test_date == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="gre">GRE/GMAT</label>
              <input
                type="text"
                id="gre"
                v-model="results.gre"
                :disabled="results.status_gre == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_gre == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="greDate">GRE/GMAT Date</label>
              <input
                type="date"
                value=""
                id="greDate"
                v-model="results.gre_date"
                :disabled="results.status_gre_date == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_gre_date == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in">
            <div class="customInput">
              <label for="masterGPA">GPA Магистратура</label>
              <input
                type="text"
                id="masterGPA"
                v-model="results.gpa_master"
                :disabled="results.status_gpa_master == 1"
                @change="mainIsChanged()"
              />
              <img
                src="@/assets/icons/galochka.svg"
                class="customInput__img"
                v-if="results.status_gpa_master == 1"
              />
            </div>
          </div>
          <div class="result__inputs__in" style="width: 100%">
            <div class="customInput">
              <label>Другое</label>
              <textarea
                v-model="results.other"
                placeholder="Дополнительная информация"
                @change="mainIsChanged()"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="result__buttons">
          <button class="result__buttons__save" @click="newResults()">
            Применить
          </button>
          <button class="result__buttons__delete" @click="reload()">
            Сбросить
          </button>
        </div>
        </template>
      </div>
      <div class="document" v-if="selectedTab == 3">
        <div v-if="userTabLoading" class="home-sk-form" aria-busy="true" aria-label="Загрузка документов">
          <div v-for="n in 6" :key="n" class="sk sk--block" />
        </div>
        <template v-else>
        <p class="document__title">Файлы и документы</p>
        <div class="document__block">
          <div
            class="document__block__in"
            v-for="item in documents"
            :key="item.id"
          >
            <div class="document__block__in__left">
              <img src="@/assets/icons/file.svg" />
            </div>
            <div class="line2"></div>
            <div class="document__block__in__right">
              <a
                :href="item.link"
                class="document__block__in__right__pdf"
                :class="{
                  approved: item?.status == 1,
                  notApproved: item?.status == 2,
                }"
                >Link
              </a>
              <p
                class="document__block__in__right__name"
                :class="{
                  approved: item?.status == 1,
                  notApproved: item?.status == 2,
                }"
              >
                {{ item?.name }}
              </p>
              <div
                class="document__block__in__right__undefined"
                v-if="item?.status == 0"
              >
                <p
                  class="document__block__in__right__undefined__left"
                  @click="changeStatus(item, 1)"
                >
                  Approve
                </p>
                <div class="line2"></div>
                <p
                  class="document__block__in__right__undefined__right"
                  @click="changeStatus(item, 2)"
                >
                  Not yet
                </p>
              </div>
              <div
                class="document__block__in__right__approved"
                v-if="item?.status == 1"
              >
                Approved
              </div>
              <div
                class="document__block__in__right__not"
                v-if="item?.status == 2"
              >
                Not yet
              </div>
            </div>
          </div>
        </div>
        <p class="document__title">Дополнительные документы</p>
        <div class="document__info">
          <img src="@/assets/icons/info.svg" />
          <p>Здесь будут отображаться данные добавленные Вашим куратором</p>
        </div>
        </template>
      </div>
  </PlatformLayout>
  <Teleport to="body">
    <GuestExpired v-if="expired" @close="leaveAccount()" />
  </Teleport>
</template>
<script>
import PlatformLayout from "@/components/platform/PlatformLayout.vue";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import extend from "@/components/newPlatform/extend.vue";
import progressBar from "@/components/newPlatform/progressBar.vue";
import ReviewModal from "@/components/newPlatform/reviewModal.vue";
import customSelect from "@/components/customSelect.vue";
import GuestExpired from "@/components/guest/expired.vue";
import GuestBanner from "@/components/guest/banner.vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import axios from "axios";
import store from "@/store";
import { mapActions } from "vuex";
export default {
  components: {
    Swiper,
    SwiperSlide,
    PlatformLayout,
    extend,
    progressBar,
    ReviewModal,
    customSelect,
    GuestExpired,
    GuestBanner,
  },
data() {
    return {
        depthStudy: [
            {
                id: 0,
                title: "Технический",
            },
            {
                id: 1,
                title: "Гуманитарий",
            },
            {
                id: 2,
                title: "Другое",
            },
        ],
      selectedTab: 0,
      mainTabLoading: false,
      userTabLoading: false,
      openExtend: false,
      selectedDocumentId: null,
      selectedDocumentName: "",
      swiperRefCategory: null,
      swiperRef: null,
      activeSwiperIndex: 0,
      agree: false,
      openReview: false,
      contacts: false,
      drive_link: false,
      results: {
        school: "",
        gpa_school: "",
        depth_study: "",
        placement_test_date: "",
        ielts_date: "",
        ielts: "",
        sat: "",
        gre: "",
        gpa_bachelor: "",
        gpa_master: "",
        kaz_test: "",
        kaz_test_date: "",
        gre_date: "",
      },
      deadlines: [],
      circleColor: "",
      circlePercent: 50,
      userData: [],
      intSch: [],
      risks: [],
      individual: [],
      admissions: [],
      guestPreviewPrograms: [
        { initial: 'H', flag: '🇺🇸', university: 'Harvard University', program: 'Master of Laws (LLM)', category: 'Social Studies', gradient: 'linear-gradient(135deg, #A51C30, #680e1c)' },
        { initial: 'S', flag: '🇺🇸', university: 'Stanford University', program: 'Computer Science (MS)', category: 'Tech & IT', gradient: 'linear-gradient(135deg, #8C1515, #4a0808)' },
        { initial: 'M', flag: '🇺🇸', university: 'Massachusetts Institute of Technology', program: 'Finance (MFin)', category: 'Business', gradient: 'linear-gradient(135deg, #2c3e50, #1a2530)' },
        { initial: 'B', flag: '🇬🇧', university: 'University of Birmingham', program: 'Computer Science (MSc)', category: 'Tech & IT', gradient: 'linear-gradient(135deg, #6b1a3a, #3d0f22)' },
      ],
      guestRisks: [
        'Упущенные дедлайны и сроки подачи',
        'Ошибки в эссе и мотивационном письме',
        'Несоответствие профиля требованиям',
        'Пропущенные стипендии и гранты',
      ],
      guestDeadlinesPreview: [
        { title: 'Дедлайн подачи документов', date: 'будет назначен' },
        { title: 'Подготовка мотивационного письма', date: 'будет назначен' },
        { title: 'Подача заявок на гранты', date: 'будет назначен' },
      ],
      guestScholarshipPreview: [
        { title: 'Статус заявки на стипендию', status: 'будет отслеживаться' },
        { title: 'Подходящие гранты', status: 'будут подобраны' },
      ],
      isMainChanged: false,
      documents: [],
      myBuys: [],
      final: [
        {
          img: "galochka",
          name: "Утвержден. программы",
          status: "green",
        },
        {
          img: "galochka",
          name: "Утвержден. программы",
          status: "green",
        },
        {
          img: "galochka",
          name: "Утвержден. программы",
          status: "green",
        },
        {
          img: "mail",
          name: "Реком. письмо 2",
        },
        {
          img: "file",
          name: "Эссе",
        },
        {
          img: "file",
          name: "Эссе 2",
        },
        {
          img: "dots",
          name: "Дополн.",
        },
      ],
      tabs: [
        {
          name: "Главная",
        },
        {
          name: "Данные",
        },
        {
          name: "Результаты",
        },
        // {
        //     name: 'Документы'
        // }
      ],
      breakpoints: {
        0: {
          slidesPerView: 3.4,
          spaceBetween: 20,
        },
      },
      genders: [
        {
          title: "Мужчина",
          id: 0,
        },
        {
          title: "Женщина",
          id: 1,
        },
      ],
      countries: [],
      circleInColor: "#ebe4e4",
      cities: [],
      expired: false,
    };
  },
  computed: {
    focusCard() {
      const isExpired = this.agree && (this.agree.status == 2 || this.agree.left_days == 0);
      const isWarning = this.agree && this.agree.status == 1 && this.agree.left_days <= 30 && this.agree.left_days > 0;

      const allDeadlines = [
        ...(this.deadlines?.generalEnglishes || []),
        ...(this.deadlines?.tests || []),
      ];
      const upcoming = allDeadlines.find(d => d.is_coming && d.status != 0);
      const nearest = allDeadlines.find(d => d.deadline) || null;
      const programCount = this.admissions?.length || 0;

      if (isExpired) {
        return {
          theme: 'focus-card--danger',
          stats: [
            { value: 'Нет доступа', label: 'к работе с куратором', valueClass: 'val-red' },
            { value: programCount || 'Нет', label: programCount ? 'программ выбрано' : 'выбранных программ', valueClass: '' },
            { value: 'Заблокировано', label: 'добавление документов', valueClass: 'val-muted' },
          ],
          cta: 'Продлить договор',
        };
      }

      if (isWarning) {
        return {
          theme: 'focus-card--warning',
          stats: [
            { value: `${this.agree.left_days} дн.`, label: 'до окончания — продлите заранее', valueClass: 'val-orange' },
            { value: programCount || '—', label: 'программ выбрано', valueClass: '' },
            { value: nearest ? nearest.deadline : '—', label: nearest ? `ближайший срок: ${nearest.title}` : 'сроков нет', valueClass: '' },
          ],
          cta: 'Продлить',
        };
      }

      if (upcoming) {
        return {
          theme: 'focus-card--info',
          stats: [
            { value: upcoming.title, label: 'срок приближается', valueClass: 'val-blue' },
            { value: upcoming.deadline, label: 'дата дедлайна', valueClass: '' },
            { value: programCount || '—', label: 'программ выбрано', valueClass: '' },
          ],
          cta: null,
        };
      }

      return {
        theme: 'focus-card--ok',
        stats: [
          { value: `${this.agree.left_days} дн.`, label: 'договор действует', valueClass: 'val-green' },
          { value: programCount || '—', label: 'программ выбрано', valueClass: '' },
          { value: nearest ? nearest.deadline : '—', label: nearest ? `срок: ${nearest.title}` : 'сроков нет', valueClass: '' },
        ],
        cta: null,
      };
    },
    chartOptions() {
      return {
        backgroundColor: "transparent", // Делаем фон прозрачным
        data: [
          {
            type: "doughnut",
            innerRadius: "75%",
            yValueFormatString: "#,###'%'",
            dataPoints: [
              {
                name: "Осталось",
                y: this.circlePercent,
                color: this.circleColor,
              },
              {
                name: "Прошло",
                y: 100 - this.circlePercent,
                color: this.circleInColor,
              },
            ],
          },
        ],
          isSaved: false,
      };
    },
  },
  methods: {
    ...mapActions(["logoutUser", "toggleBlock", "navigateToPay"]),
    leaveAccount() {
      this.logoutUser();
      toast("Вы вышли с аккаунта.");
      this.$router.push("/");
    },
    mainIsChanged() {
      this.isMainChanged = true;
    },
    validateCyrillicSurname(event) {
      this.userData.surname = event.target.value.replace(
        /[^А-Яа-яЁёӘәҒғҚқҢңӨөҰұҮүҺһІі]/g,
        ""
      );
    },
    validateCyrillicName(event) {
      this.userData.name = event.target.value.replace(
        /[^А-Яа-яЁёӘәҒғҚқҢңӨөҰұҮүҺһІі]/g,
        ""
      );
    },
    reload() {
      if (confirm("Изменения не сохранятся, вы точно хотите сбросить?")) {
        window.location.reload();
      }
    },
    changeStatus(item, id) {
      const data = {
        id: item.id,
        status: id,
      };
      axios
        .put("/platform/client/basic-documents", data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            toast.success("Успешно обновлено!");
            if (id == 1) {
              this.selectedDocumentId = item.id;
              this.selectedDocumentName = item.name;
              this.openReview = true;
            }
          } else {
            console.log(response.data);
          }
        })
        .catch((response) => {
          console.log(response.response.data.errors);
        });
    },
    newResults() {
      axios
        .post("/platform/client/academic-result", this.results, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((response) => {
          if (response.status === 201) {
            toast.success("Успешно обновлено!");
          } else {
            console.log(response.data);
          }
        })
        .catch((response) => {
          console.log(response.response.data.errors);
        });
    },
    selectTab(index) {
      if (this.isMainChanged && !this.isSaved) {
        if (
          !confirm(
            "Данные не сохранятся, вы уверены что хотите перейти на новую страницу?"
          )
        ) {
          return;
        }
      }
      this.selectedTab = index;
      this.swiperRefCategory?.slideTo(index, 500);
      this.scrollToTop();
      this.isMainChanged = false;
      this.$router.push({
        query: { tab: index },
      });
      if (this.selectedTab == 0) {
        this.getMain();
        this.getUser();
      }
      if (this.selectedTab == 1) {
        this.getUser();
        this.getBuys();
      }
      if (this.selectedTab == 2) {
        this.getUser();
      }
      if (this.selectedTab == 3) {
        this.getUser();
      }
    },
    getSwiperCategory(swiper) {
      this.swiperRefCategory = swiper;
      this.activeSwiperIndex = swiper.activeIndex;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async cityList() {
      await axios
        .get(`/platform/cities?country_id=${this.userData.country_id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.cities = res.data.data.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((err) => {});
    },
    async getMain() {
      if (this.selectedTab !== 0) return;
      this.mainTabLoading = true;
      try {
      await axios
        .get(`/platform/client/key-dates`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.deadlines = res.data.data;
        })
        .catch((err) => {})
        .catch((err) => {});
      await axios
        .get(`/platform/contacts`)
        .then((res) => {
          this.contacts = res.data.data.filter((item) => item.type_id == 3);
        })
        .catch((err) => {});
      await axios
        .get(`/platform/driver_link?user_id=${store.state.user_id}`)
        .then((res) => {
          this.drive_link = res.data.link;
        })
        .catch((err) => {});
      await axios
        .get(`/platform/client/users/international-scholarship-widgets`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.intSch = res.data.data.filter((i) => i.date);
        })
        .catch((err) => {});
      await axios
        .get(`/platform/client/users-document-widget`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.agree = res.data.data;
          this.circlePercent =
            (this.agree.left_days * 100) / this.agree.count_of_days;
          if (this.agree.status == 2) {
            this.circlePercent = 0;
          }
          if (this.circlePercent == 0) {
            this.circleInColor = "red";
          }
          if (this.circlePercent < 25) {
            this.circleColor = "#FD2D2A";
          }
          if (this.circlePercent >= 25 && this.circlePercent < 50) {
            this.circleColor = "#fd622a";
          }
          if (this.circlePercent >= 50) {
            this.circleColor = "#14D448";
          }
        })
        .catch((err) => {});
      await axios
        .get(`/platform/client/risks`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.risks = res.data.data;
        })
        .catch((err) => {});
      await axios
        .get(`/platform/client/users-individual-plans`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.individual = res.data.data;
        })
        .catch((err) => {});
      await axios
        .get(`/platform/client/user-admissions`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.admissions = res.data.data;
          this.admissions.sort(
            (a, b) => a.admission_status.priority - b.admission_status.priority
          );
          console.log('Admissions: ', this.admissions);
        })
        .catch((err) => {});
      } finally {
        this.mainTabLoading = false;
      }
    },
    async getUser() {
      this.userTabLoading = true;
      try {
        // Загружаем список стран
        const countriesRes = await axios.get(`/platform/countries`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        this.countries = countriesRes.data.data.sort((a, b) =>
          a.title.localeCompare(b.title)
        );

        // Загружаем пользователя
        const userRes = await axios.get(`/platform/client/user`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });

        const user = userRes.data?.data?.user;
        if (user) {
          this.userData = user;

          if (user.birthday) {
            this.userData.birthday = this.formatDate(user.birthday);
          }

          if (user.country_id) {
            await this.cityList(); // теперь правильно работает с await
            if (user.city_id) {
              this.userData.city_id = Number(user.city_id.id);
            }
          }
        }

        const results = userRes.data?.data?.academicResult;
        if (results) {
          this.results = results;

          if (results.gre_date) {
            this.results.gre_date = this.formatDate(results.gre_date);
          }

          if (results.sat_date) {
            this.results.sat_date = this.formatDate(results.sat_date);
          }

          if (results.ielts_date) {
            this.results.ielts_date = this.formatDate(results.ielts_date);
          }

          if (results.kaz_test_date) {
            this.results.kaz_test_date = this.formatDate(results.kaz_test_date);
          }

          if (results.placement_test_date) {
            this.results.placement_test_date = this.formatDate(
              results.placement_test_date
            );
          }
        }

        const docs = userRes.data?.data?.private_documents;
        if (docs) {
          this.documents = docs;
        }
      } catch (err) {
        console.error("Error in getUser:", err);
      } finally {
        this.userTabLoading = false;
      }
    },
    async getBuys() {
      await axios
        .get(`/platform/client/history-purchase`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.myBuys = res.data.data;
        })
        .catch((err) => {});
    },
    formatDate(date) {
      const [day, month, year] = date.split("-"); // Разделяем строку
      return `${year}-${month}-${day}`; // Формируем новую строку в нужном формате
    },
    formatDateToFetch(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    updateUser() {
      this.userData.image = "";
      this.userData.email = "";
      const payload = {
        ...this.userData,
        birthday: this.formatDateToFetch(this.userData.birthday),
      };
      axios
        .put("/platform/client/user/update", payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            toast.success("Успешно обновлено!");
            this.isSaved = true;
            this.getUser();
          } else {
            console.log(response.data);
          }
        })
        .catch((response) => {
          console.log(response.response.data.errors);
        });
    },
    openExtendEvent() {
      if (this.$store.state.role == 'guest') return;
      this.openExtend = true;
    }
  },
  mounted() {
    const tabFromQuery = this.$route.query.tab;
    if (tabFromQuery) {
      this.selectedTab = Number(tabFromQuery);
      this.swiperRefCategory?.slideTo(this.selectedTab, 0);
      this.selectTab(this.selectedTab);
    } else {
      this.selectTab(0);
    }

    const expiresAt = this.$store.state.expired;
    console.log(`mounted`, expiresAt);
    if (this.$store.state.role == "guest") {
      console.log(`role`, this.$store.state.role);
      if (expiresAt) {
        const now = new Date();
        const expireDate = new Date(expiresAt);
        console.log(`role`, now);

        // Если срок истёк или ровно сегодня
        if (now >= expireDate) {
          this.expired = true;
        } else {
          this.expired = false;
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.customBorder {
  border: 1px solid #14d448 !important;
}

.backGreen {
  background-color: #00d928;
}
.backWhite {
  background-color: white;
}

.noneClass {
  display: none !important;
}

.backRed {
  background-color: #fd622a;
}

// .textGreen {
//     color: #00D928;
// }

// .textRed {
//     color: #fd622a;
// }

.main {
  display: flex;
  flex-direction: column;
  gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

  &__top {
    display: none;
    @media (min-width: 640px) {
      display: flex;
      justify-content: space-between;
    }

    &__center {
      box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
        background: #ffffff;
        border: 1px solid #e8eaed;
        padding: 20px 24px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: 16px;
        width: 100%;
        height: 830px;
        overflow: auto;
      @media (min-width: 1920px) {
        height: 930px;
      }
      &__block {
        display: flex;
        flex-direction: column;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

        &__in {
          display: flex;
          justify-content: space-between;

          &__left {
            width: 42%;
            padding: 5px;
            box-shadow: 0px 0px 8px 4px #0000004d inset;
            border-radius: 5px;
            aspect-ratio: 1;
            height: fit-content;
            background-position: center;
            background-size: cover;
          }

          &__right {
            width: 55%;
            display: flex;
            flex-direction: column;
            gap: 5px;

            &__title {
              color: #fd2d2a;
            }

            &__sub {
              font-size: min(
                max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))),
                20px
              );
              font-weight: 600;
              display: -webkit-box;
              -webkit-line-clamp: 2; // ограничение на 2 строки
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            &__deadline {
              color: #0000008a;
            }
          }
        }
      }
    }

    &__left,
    &__center,
    &__right {
      width: 32%;
      display: flex;
      flex-direction: column;
      gap: 40px;
    }

    .status {
      @media (min-width: 1920px) {
        height: 350px;
      }
      display: flex;
      background-image: url("@/assets/icons/backGroundStatus.png");
      background-position: center;
      background-size: cover;
      padding: 20px 24px;
      flex-direction: column;
      gap: 20px;
      border-radius: 16px;
      width: 100%;
      height: 250px;
      border: 1px solid rgba(0,0,0,0.06);
      box-shadow: 0 2px 8px rgba(16, 24, 40, 0.07);
      &__block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__left {
          width: 40%;
          aspect-ratio: 1;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #0000008a;
          position: relative;

          div {
            height: 100% !important;
          }

          p {
            position: absolute;
          }
        }

        &__right {
          width: 57%;
          display: flex;
          flex-direction: column;
          gap: 10px;

          &__title {
            font-size: min(
              max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))),
              24px
            );
            font-weight: 700;
            color: #fd2d2a;
          }

          &__sub {
            color: #0000008a;
          }

          button {
            width: 80%;
            border: none;
            background: #e8192c;
            padding: 10px 0;
            color: white;
            border-radius: 10px;
            font-size: 13px;
            font-weight: 700;
            font-family: inherit;
            cursor: pointer;
            transition: background 0.15s;
            &:hover { background: #c8101f; }
          }
        }
      }
    }

    .deadlines {
      background-image: url("@/assets/icons/backGroundDate.png");
      background-color: white;
      background-position: center;
      background-size: cover;
      padding: 20px 24px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      border-radius: 16px;
      border: 1px solid #e8eaed;
      box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
      width: 100%;
      height: 540px;
      overflow: auto;

      &__block {
        display: flex;
        flex-direction: column;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

        &__in {
          display: flex;
          flex-direction: column;
          gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);

          &__title {
            font-size: 15px;
            font-weight: 800;
            color: #111827;
            letter-spacing: -0.01em;
          }

          &__new {
            display: flex;
            flex-direction: column;
            gap: min(
              max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))),
              20px
            );

            &__in {
              display: flex;
              justify-content: space-between;
              align-items: center;

              &__left {
                display: flex;
                align-items: center;
                gap: min(
                  max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))),
                  15px
                );

                &__mini {
                  width: 22px;
                  height: 22px;
                  border: 1px solid rgb(255, 255, 255);
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  &__in {
                    height: 16px;
                    width: 16px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .grant,
    .risk,
    .contact {
      padding: 20px 24px;
      display: flex;
      flex-direction: column;
      gap: 18px;
      border-radius: 16px;
      width: 100%;
      height: 250px;
      @media (min-width: 1920px) {
        height: 283.3333px;
      }
      position: relative;

      &__in__backdrop {
        position: absolute;
        z-index: 80;
        inset: 0;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .grant {
      box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
      background: #ffffff;
      border: 1px solid #e8eaed;
      &__block {
        display: flex;
        justify-content: space-between;

          &__in {
          width: 48%;
          padding: 12px 10px;
          border: 1px solid #e8eaed;
          background: #f8f9fb;
          text-align: center;
          display: flex;
          flex-direction: column;
          gap: 10px;
          border-radius: 10px;
          &__name {
            color: #6b7280;
            flex-grow: 1;
            font-size: 13px;
          }

          &__date {
            font-size: 15px;
            font-weight: 800;
            color: #111827;
          }
        }
      }
    }

    .risk {
      background: #FFFBEB;
      box-shadow: 0px 4px 3px 1px #0000000d;
      position: relative;
      overflow: hidden;
      border-left: 3px solid #F59E0B;

      &::after {
        content: '';
        position: absolute;
        top: -40px;
        right: -40px;
        width: 160px;
        height: 160px;
        background: radial-gradient(circle, rgba(245, 158, 11, 0.18) 0%, transparent 65%);
        pointer-events: none;
      }

      .customTitle {
        position: relative;
        z-index: 2;
        p {
          color: #92400E;
        }
      }

      &__block {
        position: relative;
        z-index: 2;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 6px;

        &__in {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            display: flex;
            align-items: flex-start;
            gap: 9px;
            font-size: 13px;
            color: #44403C;
            line-height: 1.45;

            &::before {
              content: '';
              width: 6px;
              height: 6px;
              min-width: 6px;
              border-radius: 50%;
              background: #F59E0B;
              margin-top: 7px;
            }
          }
        }
      }
    }

    .contact {
      box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
      background: #ffffff;
      border: 1px solid #e8eaed;
      &__block {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: auto 0;
        .swiper {
          width: 100%;
          &-slide {
            display: flex;
            flex-direction: column;
            gap: min(
              max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))),
              15px
            );
            align-items: center;
            cursor: pointer;
            font-size: min(
              max(6px, calc(0.375rem + ((1vw - 7.68px) * 0.5208))),
              12px
            );

            img {
              width: 100%;
              aspect-ratio: 1;
              object-fit: contain;
            }
          }
        }
      }
    }
  }

  &__bot {
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .plan,
    .final {
      box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
      background: #ffffff;
      border: 1px solid #e8eaed;
      padding: 20px 24px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      border-radius: 16px;
    }

    .plan {
      width: 32%;

      &__block {
        display: flex;
        justify-content: space-between;

        &__in {
          width: 45%;
          display: flex;
          flex-direction: column;
          gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
          align-items: center;
          color: #0000008a;

          &__top {
            width: 100%;
            aspect-ratio: 1.2;
            border: 1px solid #0000001a;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10px;

            img {
              width: 45px;
            }
          }
        }
      }
    }

    .final {
      width: 66%;
      &__block {
        display: flex;
        gap: 10px;
        align-items: center;
        &__in {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          cursor: pointer;
          gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);

          img {
            width: min(
              max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))),
              40px
            );
          }

          &__top {
            width: 100%;
            aspect-ratio: 0.8;
            border: 1px solid #0000001a;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    &__top {
      flex-direction: column;
      gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

      &__left,
      &__center,
      &__right {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
      }

      .status {
        padding: 10px;
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);

        &__block {
          &__left {
            width: 30%;
          }

          &__right {
            width: 65%;

            &__title {
              font-size: min(
                max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))),
                24px
              );
            }

            button {
              width: 50%;
            }
          }
        }
      }

      .deadlines {
        padding: 10px;
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
        font-size: 14px !important;

        &__block {
          gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);

          &__in {
            gap: min(
              max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))),
              15px
            );

            &__title {
              font-size: 16px;
            }
          }
        }
      }

      &__center {
        padding: 10px;
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);

        &__block {
          gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);

          &__in {
            &__left {
              width: 20%;
            }

            &__right {
              width: 78%;
              font-size: 14px !important;

              &__sub {
                font-size: min(
                  max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))),
                  14px
                );
              }
            }
          }
        }
      }

      .grant,
      .risk,
      .contact {
        padding: 10px;
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
      }

      .grant {
        &__block {
          &__in {
            padding: 10px;
            gap: min(
              max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))),
              15px
            );

            &__date {
              font-size: min(
                max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))),
                14px
              );
            }
          }
        }
      }
    }

    &__bot {
      flex-direction: column;
      gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

      .plan,
      .final {
        padding: 10px;
        width: 100%;
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
      }

      .plan {
        &__block {
          &__in {
            width: 49%;
          }
        }
      }

      .final {
        &__block {
          flex-wrap: wrap;
          gap: 2%;
          row-gap: min(
            max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))),
            15px
          );

          &__in {
            width: 32%;

            &__top {
              aspect-ratio: 1;
            }
          }
        }
      }
    }
  }
}

.customTitle {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #9ca3af;

  p { margin: 0; }

  .line {
    border-top: 1px solid #f0f1f3;
    border-color: #f0f1f3;
  }

  @media (max-width: 768px) {
    font-size: 11px;
  }
}

.line1 {
  border: 1px solid #0000001a;
}

.line {
  border-top: 1px solid #0000001a;
  width: 100%;
}

.line2 {
  border-left: 1px solid #0000001a;
  height: 100%;
}

/* ── Личный кабинет: вкладки ───────────────── */
.home-tabs {
  width: 100%;
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 14px;
  padding: 4px 12px 0;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.05);
  box-sizing: border-box;
  border-bottom: 2px solid #f0f1f3;
}

.home-tabs__swiper {
  width: 100%;
}

.home-tabs__slide {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: auto !important;
  min-height: 52px;
  padding: 14px 24px 12px !important;
  margin: 0 !important;
  margin-bottom: -2px !important;
  border-radius: 0;
  cursor: pointer;
  font-family: 'Manrope', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  color: #6b7280;
  white-space: nowrap;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  transition: color 0.15s, border-color 0.15s;
  box-sizing: border-box;

  &:hover {
    color: #111827;
  }

  &--active {
    color: #111827 !important;
    font-weight: 700;
    font-size: 17px;
    border-bottom-color: #e8192c;
  }
}

@media (max-width: 768px) {
  .home-tabs {
    padding: 2px 8px 0;
    border-radius: 12px;
  }

  .home-tabs__slide {
    min-height: 48px;
    padding: 12px 16px 10px !important;
    font-size: 15px;
    border-bottom-width: 3px;

    &--active {
      font-size: 16px;
    }
  }
}

.general {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 640px) {
    flex-direction: column-reverse;
  }

  &__top,
  &__bot {
    &__title {
      font-size: 18px;
      font-weight: 800;
      color: #111827;
      letter-spacing: -0.01em;
      padding-bottom: 18px;
      border-bottom: 1px solid #f0f1f3;
      margin: 0;
    }

    display: flex;
    flex-direction: column;
    gap: 24px;
    background: #fff;
    border-radius: 16px;
    padding: 28px 32px;
    border: 1px solid #e8eaed;
    box-shadow: 0 1px 4px rgba(16, 24, 40, 0.05);
  }

  &__top {
    &__block {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

        &__inMobile{
            display: none;
        }

      &__in {
        width: calc(25% - 12px);
        box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
        background: #f8f9fb;
        padding: 20px 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        border-radius: 14px;
        font-weight: 700;
        border: 1px solid #f0f1f3;
        transition: box-shadow 0.15s, transform 0.15s;
        cursor: pointer;

        &:hover {
          box-shadow: 0 6px 20px rgba(16, 24, 40, 0.1);
          transform: translateY(-2px);
        }

        img {
          width: 56px;
          height: 56px;
          object-fit: cover;
          border-radius: 10px;
        }

        &__name {
          font-size: 15px;
          font-weight: 700;
          color: #111827;
          text-align: center;
        }

        &__sub {
          font-size: 13px;
          color: #e8192c;
          font-weight: 600;
        }
      }
    }
  }

  &__bot {
    &__inputs {
      display: flex;
      flex-wrap: wrap;
      gap: 2%;
      row-gap: 20px;

      &__in {
        width: 32%;
      }
    }

    &__buttons {
      display: flex;
      gap: 12px;
      padding-top: 8px;

      button {
        padding: 11px 28px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 700;
        font-family: inherit;
        cursor: pointer;
        transition: all 0.2s;
      }

      &__save {
        color: #fff;
        background: #0f1f3d;
        border: 1px solid #0f1f3d;

        &:hover {
          background: #1a3560;
          border-color: #1a3560;
        }
      }

      &__delete {
        background: #fff;
        border: 1px solid #e5e7eb !important;
        color: #374151;

        &:hover {
          background: #f9fafb;
          border-color: #d1d5db !important;
        }
      }
    }
  }

  @media (max-width: 768px) {
      .customInput input {
          width: 100%;
          height: 42px;
          font-size: 16px;
      }
    &__top,
    &__bot {
      gap: 16px;
      padding: 20px 16px;
      border-radius: 14px;

      &__title {
        font-size: 16px;
      }
    }

    &__top {
      &__block {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          &__inMobile{
              display: flex;
              flex-wrap: wrap;
              flex-direction: row;

              &__subBlock{
                  padding-left: 16px;
                  &__t0 {
                      font-size: 14px;
                      color: #FD2D2A;
                  }
                  &__t1{
                      font-size: 16px;
                      font-weight: bold;
                      margin: 4px 0;
                  }
                  &__t2{
                      font-size: 14px;
                      color:#ccc;
                  }
              }
          }
        &__in {
            display: none;
          width: 49%;
          gap: 10px;
          padding: 10px;

          .line { display: none; }
          &__name { font-size: 16px; }
        }
          &__inMobile{
              img {
                  padding: 5px 3px;
                  border: 1px solid #e8eaed;
                  border-radius: 14px;
              }
          }
      }
    }

    &__bot {
      &__inputs {
        &__in {
          width: 49%;
          input { font-size: 15px; }
        }
      }

      &__buttons {
          flex-wrap: wrap;
          flex-direction: column;
        button {
          width: 100%;
          padding: 12px 0;
          font-size: 15px;
        }
      }
    }
  }

  @media (max-width: 640px) {
    &__bot {
      &__inputs {
        &__in {
          width: 100%;
        }
      }
    }
  }
}

.result {
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: #fff;
  border-radius: 16px;
  padding: 28px 32px;
  border: 1px solid #e8eaed;
  box-shadow: 0 1px 4px rgba(16, 24, 40, 0.05);

  &__title {
    font-size: 18px;
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.01em;
    padding-bottom: 18px;
    border-bottom: 1px solid #f0f1f3;
    margin: 0;
  }

  &__inputs {
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
    row-gap: 20px;

    &__in {
      width: 32%;
    }
  }

  &__info {
    display: flex;
    gap: 16px;
    align-items: center;
    font-size: 13px;
    color: #6b7280;

    img {
      width: 16px;
      height: 16px;
    }
  }

  &__buttons {
    display: flex;
    gap: 12px;
    padding-top: 8px;

    button {
      padding: 11px 28px;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 700;
      font-family: inherit;
      cursor: pointer;
      transition: all 0.2s;
    }

    &__save {
      color: #fff;
      background: #0f1f3d;
      border: 1px solid #0f1f3d;

      &:hover {
        filter: none !important;
        opacity: 1 !important;
        background: #1a3560;
        border-color: #1a3560;
      }
    }

    &__delete {
      background: #fff;
      border: 1px solid #e5e7eb !important;
      color: #374151;

      &:hover {
        filter: none !important;
        background: #f9fafb;
        border-color: #d1d5db !important;
        color: #374151;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 20px 16px;
    border-radius: 14px;

    &__title {
      font-size: 16px;
    }

    &__inputs {
      &__in { width: 49%; }
    }

    .customInput input {
      width: 100%;
      height: 42px;
      font-size: 16px;
    }

    &__info { display: none; }

    &__buttons {
        flex-wrap: wrap;
        flex-direction: column;
      button {
        width: 100%;
        padding: 12px 0;
        font-size: 15px;
      }
    }
  }

  @media (max-width: 640px) {
    &__inputs {
      &__in { width: 100%; }
    }
  }
}

.approved {
  color: #14d448;
}

.notApproved {
  color: #ff9500;
}

.document {
  display: flex;
  flex-direction: column;
  gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

  &__title {
    font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
    font-weight: 700;
    margin-top: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
  }

  &__block {
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
    row-gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);

    &__in {
      width: 23.5%;
      padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)
        min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0px 4px 3px 1px #0000000d;
      background: #ffffff;
      border-radius: 10px;

      &__left {
        width: 15%;

        img {
          width: 100%;
        }
      }

      &__right {
        width: 75%;
        display: flex;
        flex-direction: column;
        gap: 5px;

        &__name {
          font-weight: 700;
          flex-grow: 1;
        }

        &__undefined {
          display: flex;
          justify-content: space-between;
          padding: 10px
            min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
          border: 1px solid #0000001a;
          border-radius: 10px;
          cursor: pointer;

          &__left {
            color: #00d928;
          }

          &__right {
            color: #ff9500;
          }
        }

        &__approved {
          padding: 10px
            min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
          background-color: #f8f8f8;
          width: fit-content;
          border-radius: 10px;
          color: #0000008a;
          cursor: pointer;
        }

        &__not {
          padding: 10px
            min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
          background-color: #ff9500;
          width: fit-content;
          color: white;
          border-radius: 10px;
          cursor: pointer;
        }
      }
    }

    &__plus {
      width: 23.5%;
      padding: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px)
        0px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 0px 8px 4px #0000000d inset;
      border: 1px solid #0000001a;
      border-radius: 10px;
      cursor: pointer;

      img {
        width: 60px;
        height: 60px;
      }
    }
  }

  &__info {
    display: flex;
    gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    align-items: center;

    img {
      width: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
      height: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    }
  }

  @media (max-width: 768px) {
    &__title {
      font-size: min(
        max(13px, calc(0.8125rem + ((1vw - 7.68px) * 0.434))),
        18px
      );
      margin-top: 0px;
    }

    &__block {
      &__in {
        width: 100%;
        align-items: center;
      }
    }
  }
}

.new {
  @media (min-width: 640px) {
    display: none;
  }
  .status {
    button {
      padding-block: 8px;
      border-radius: 12px;
      font-size: 14px;
      font-weight: 900;
      color: white;
      margin-top: 12px;
    }
  }
  .risk {
    position: relative;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      background: url(@/assets/icons/risk.png) no-repeat center center;
      background-size: cover;
      border-radius: 12px;
    }
  }
}
// ─── Focus Card ───────────────────────────────────────────────────────────────
// ─── Guest Locked Preview (deadlines / scholarship) ──────────────────────────
.guest-locked-preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0.78;

  &--compact {
    gap: 8px;
  }

  &__item {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 9px;
  }

  &__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #C4C9D4;

    &--blue {
      background: #94B8CC;
    }
  }

  &__title {
    font-size: 13px;
    color: #4B5563;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__meta {
    font-size: 11px;
    color: #9CA3AF;
    margin: 0;
    font-style: italic;
  }

  &__hint {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    color: #9CA3AF;
    margin: 4px 0 0;
    padding-top: 8px;
    border-top: 1px dashed #E5E7EB;
  }
}

// ─── Guest Locked Program Cards ───────────────────────────────────────────────
.guest-prog-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.03);
  position: relative;
  transition: transform 0.2s ease;

  &__thumb {
    width: 64px;
    min-width: 64px;
    height: 64px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15), transparent 60%);
    }
  }

  &__initial {
    font-size: 28px;
    font-weight: 700;
    color: white;
    font-family: 'Times New Roman', Georgia, serif;
    line-height: 1;
    letter-spacing: -0.5px;
    z-index: 1;
  }

  &__flag {
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 22px;
    height: 22px;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    line-height: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    z-index: 2;
    overflow: hidden;
  }

  &__info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding-right: 24px;
  }

  &__program {
    font-size: 14px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__uni {
    font-size: 12px;
    color: #9CA3AF;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__tags {
    display: flex;
    gap: 6px;
    margin-top: 6px;
  }

  &__tag {
    font-size: 10px;
    padding: 3px 9px;
    border-radius: 12px;
    background: #F3F4F6;
    color: #4B5563;
    font-weight: 500;
    line-height: 1.4;

    &--elite {
      background: #FEE2E2;
      color: #DC2626;
      font-weight: 600;
    }
  }

  &__lock {
    position: absolute;
    top: 12px;
    right: 12px;
    color: #C4C9D4;
    display: flex;
  }
}

.guest-prog-unlock {
  align-self: flex-start;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  background: #11415D;
  color: white;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover { opacity: 0.85; }
}

// ─── Guest Value Card ──────────────────────────────────────────────────────────
.guest-value-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 18px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 250px;
  box-shadow: 0px 4px 3px 1px #0000000d;

  &__header {
    display: flex;
    align-items: center;
    gap: 7px;

    p {
      font-size: 11px;
      font-weight: 700;
      color: #11415D;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      margin: 0;
    }
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 7px;
    flex: 1;

    li {
      display: flex;
      align-items: center;
      gap: 9px;
      font-size: 13px;
      color: #374151;

      &::before {
        content: '';
        width: 7px;
        height: 7px;
        min-width: 7px;
        border-radius: 50%;
        background: #11415D;
        opacity: 0.45;
      }
    }
  }

  &__btn {
    align-self: flex-start;
    border: none;
    border-radius: 8px;
    padding: 9px 18px;
    background: #11415D;
    color: white;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.85;
    }
  }
}

.focus-card {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  border: 1px solid #F0F2F5;
  animation: slideDown 0.35s ease;

  &__accent {
    width: 5px;
    align-self: stretch;
    flex-shrink: 0;
  }

  &__body {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 18px 24px;
    gap: 0;
  }

  &__stat {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding-right: 24px;
    border-right: 1px solid #F0F2F5;

    &:last-child {
      border-right: none;
      padding-right: 0;
      padding-left: 24px;
    }

    &:not(:first-child):not(:last-child) {
      padding-left: 24px;
    }

    &__value {
      font-size: 22px;
      font-weight: 800;
      color: #111827;
      letter-spacing: -0.02em;
      line-height: 1;
    }

    &__label {
      font-size: 12px;
      color: #9CA3AF;
      font-weight: 500;
    }
  }

  &__cta {
    margin: 12px 20px 12px 0;
    padding: 10px 20px;
    border-radius: 10px;
    border: none;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
    transition: transform 0.15s, box-shadow 0.15s;
    flex-shrink: 0;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(0,0,0,0.15);
    }
  }

  &--danger {
    .focus-card__accent { background: #FD2D2A; }
    .focus-card__cta { background: #FD2D2A; color: #fff; }
  }

  &--warning {
    .focus-card__accent { background: #F59E0B; }
    .focus-card__cta { background: #F59E0B; color: #fff; }
  }

  &--ok {
    .focus-card__accent { background: #14D448; }
  }
}

.val-red   { color: #FD2D2A !important; }
.val-orange { color: #F59E0B !important; }
.val-green { color: #14D448 !important; }
.val-blue  { color: #2488C3 !important; }
.val-muted { color: #9CA3AF !important; font-size: 14px !important; }

.focus-card--info {
  .focus-card__accent { background: #2488C3; }
}

// ─── Empty States ─────────────────────────────────────────────────────────────
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px 20px;
  width: 100%;

  &--small { padding: 20px; }

  &__text {
    font-size: 13px;
    color: #9CA3AF;
    text-align: center;
    margin: 0;
    line-height: 1.45;
  }

  &__btn {
    background: none;
    border: none;
    color: #11415D;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    padding: 0;
    transition: opacity 0.15s;
    &:hover { opacity: 0.7; }
  }
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
